import { render, staticRenderFns } from "./ApplicantPersonalData.vue?vue&type=template&id=11563cd5&"
import script from "./ApplicantPersonalData.vue?vue&type=script&lang=js&"
export * from "./ApplicantPersonalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports